import { render } from "./CopyUrl.vue?vue&type=template&id=18d241c0"
import script from "./CopyUrl.vue?vue&type=script&lang=js"
export * from "./CopyUrl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__